<template>
  <div class="flex-row app-icon" :class="[{ collapse: collapse }]">
    <div
      class="icon24 resize-icon-collapse"
      :class="{ 'mr-2': !collapse }"
      v-if="collapse"
      @click="toogleClick"
    ></div>
    <a href="/" class="logo-img">
      <img
        v-if="!collapse"
        src="@/assets/images/logo.svg"
        class="app-logo"
        :class="{ 'mr-2': !collapse }"
    /></a>
    <!-- <a class="title-bold-logo" href="/" v-if="!collapse">MISA Mimosa</a> -->
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { ModuleContext } from '@/stores/moduleConst';

export default {
  props: {
    collapse: {
      default: false,
      type: Boolean,
    },
  },
  data: () => {
    return {
      collapseWait: false,
    };
  },
  methods: {
    ...mapActions({
      updatedLeftMenuCollapse: ModuleContext + '/getLeftMenuCollapse',
    }),

    /**
     * collapse/expand menu
     * NXCHIEN 19.06.2022
     */
    toogleClick() {
      this.$emit('toogle', this.collapse);
      this.setLeftMenuCollapse(!this.collapse);
      setTimeout(() => {
        this.collapseWait = this.collapse;
      }, 50);
    },

    /**
     * Set độ rộng left menu
     * NXCHIEN 19.06.2022
     */
    setLeftMenuCollapse(collapse) {
      const me = this;
      me.updatedLeftMenuCollapse(collapse);
    },
  },
};
</script>

<style lang="scss">
.app-icon {
  width: $main-left-menu-width;
  background-color: $main-left-menu-bg;
  color: #fff;
  min-width: $main-left-menu-width;
  display: flex;
  align-items: center;
  &.collapse {
    width: $main-left-menu-collapse-width;
    padding-left: 15px;
    min-width: $main-left-menu-collapse-width;
  }
  transition: width 0.2s;
}

.logo-img {
  display: flex;
  align-items: center;
  padding-left: 16px;
  width: 100%;
}

.nav-app::before {
  background-position: -456px -216px;
}
.app-logo {
  cursor: pointer;
}
</style>
